import { Reveal, Overline } from "./Reveal";
import { PROCESS } from "../../lib/site";

export default function Process() {
  return (
    <section id="process" className="relative bg-warm-white pt-10 pb-12 md:pt-16 md:pb-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-16">
          <Reveal><Overline>The Process</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl text-ocean-teal leading-tight">
              A refined four-step process, considered from your first enquiry to the finished result.
            </h2>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8">
          {PROCESS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.1}>
              <div className="group border-t border-border-stone pt-6">
                <span className="block font-serif text-5xl md:text-6xl text-antique-gold/70 group-hover:text-antique-gold transition-colors">
                  {p.n}
                </span>
                <h3 className="mt-6 font-serif text-2xl text-ocean-teal">{p.title}</h3>
                <p className="mt-3 font-sans font-light text-sm leading-relaxed text-charcoal/70">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
